StepHandler = App.loadClass 'grower::handlers/placement/StepHandler'

class exports.RangedClickableTableHandler extends StepHandler

    inputSel: 'div.spp-clickable-cell'

    addValidationRules: () ->
        @validator.registerRule
            selector: '.validate-ranged-clickable-cell'
            text: '%s requires input'
            func: (elem) =>
                fieldID = $(elem).attr('data-field')
                group = @getInputEl(field: fieldID)

                return ( group.filter('.active').length > 0 )


    getFieldAspect: (fieldID, aspectID) ->
        selected = @getInputEl(field: fieldID, aspect: aspectID).is('.active')

        retval =
            value: selected

        return retval


    setFieldAspect: (fieldAspect) ->
        if not fieldAspect.fields_id? or not fieldAspect.aspects_id?
            return

        if fieldAspect.value
            input = @getInputEl
                field: fieldAspect.fields_id
                aspect: fieldAspect.aspects_id

            input.addClass('active')


    afterLoadLayout: (sel, data) ->
        super(sel, data)

        step = this

        # add radio-button-esque click handling
        @getInputEl().on 'click', () ->
            el = $(this)

            if el.is('.disabled')
                return

            group = step.getInputEl
                field: el.attr('data-field')

            selectedCell = group.filter('.active')

            if selectedCell.length is 1 and not selectedCell.is(el)

                selecting = false
                group.each () ->
                    input = $(this)

                    if input.is(el) or input.is(selectedCell)
                        if selecting then stopSelecting = true
                        else selecting = true

                    if not selecting then return true

                    if not input.is(selectedCell)
                        $(input).addClass('active').trigger('change')

                    if stopSelecting then return false

            else
                if el.hasClass('active')
                    el.removeClass('active')
                else
                    el.addClass('active')

                group.trigger('change')


        # add fill-down logic to the option headers
        @layoutSelector.find('th[data-aspect]').on 'click', () ->

            group = step.getInputEl
                aspect: $(this).attr('data-aspect')

            # if all the cells for the aspect are selected, then deselect them rather than selecting
            deselect = ( group.length is group.filter('.active').length )

            group.each () ->
                input = $(this)

                if deselect
                    if input.hasClass('active')
                        input.click()
                else
                    # only select the currently unselected cells
                    if not input.hasClass('active')
                        input.click()
